import React, { useEffect } from "react";
//import PropTypes from 'prop-types';

import { FormLayout, FormSection } from "playground/cms/Form";
import Field from "containers/Field";
import { Property, PropertyGrid } from "playground/cms/fields/Properties";
import { MediaField } from "playground/cms/fields/Media";
import { useData, useFetch, useFormField } from "state/hooks";
import TagsField from "playground/cms/fields/TagsField";
import { useSelector } from "react-redux";
import { selectAll, selectEntity, selectIsDraft } from "state/selectors/data";
import FlatRooms from "./FlatRooms";
import Select from "components/fields/select/ControlledSelect";

function selectAllFloors(store) {
    const buildings = Object.values(store.data["apartments.buildings"] || {});
    const floors = [];
    buildings.forEach((building) => {
        building.floors.forEach((floor) => {
            const floorData = selectEntity(store, "apartments.floors", floor);
            floors.push({
                id: floor,
                label: building.name + " > " + floorData.name,
            });
        });
    });
    return floors;
}

function SelectFloor(props) {
    const { value, onChange } = useFormField(props.id);
    const floorOptions = useSelector(selectAllFloors);
    const visibleValue = floorOptions.find((opt) => opt.id === value);
    useFetch({
        type: "apartments.buildings",
        list: "floor-select",
        url: "apartments/buildings",
        yieldData: true,
        enable: true,
        once: false,
    });
    useEffect(() => {}, []);
    return (
        <Select
            label={"Budynek / piętro"}
            value={visibleValue?.label || value}
            onChange={onChange}
            options={floorOptions}
            nullable={false}
        />
    );
}

export function FlatsForm(props) {
    const { type, id } = props;
    const { name, code_part, levels, floor } = useData(props);
    const isDraft = useSelector((store) => selectIsDraft(store, type, id));
    const label = name + " (" + code_part + ")";
    return (
        <FormLayout.Fieldset pad>
            <div className={"rows gap-md"}>
                <FormSection name={label} collapsed={!isDraft}>
                    <FormLayout.Fieldset>
                        <div className={"cols cols-2 gap-sm"}>
                            <Field id={"name"} label={"Nazwa"} />
                            <Field id={"code_part"} label={"Kod"} />
                            <Field
                                id={"type"}
                                fieldType={"select"}
                                label={"Typ"}
                                source={"schema:data.flat-type"}
                            />
                        </div>
                        <SelectFloor id={"floor"} />
                        {/*<Field*/}
                        {/*    id={"floor"}*/}
                        {/*    fieldType={"select"}*/}
                        {/*    label={"Budynek / piętro"}*/}
                        {/*    source={"api:floors"}*/}
                        {/*/>*/}
                    </FormLayout.Fieldset>
                </FormSection>

                <div className={"cols cols-2 gap-sm"}>
                    <Field
                        id={"status"}
                        fieldType={"select"}
                        label={"Dostępność"}
                        source={"schema:data.flat-status"}
                    />
                    <Field
                        id={"development_stage"}
                        fieldType={"select"}
                        label={"Etap budowy"}
                        source={"schema:data.development-stage"}
                    />
                </div>

                <PropertyGrid>
                    <Property label={"Cena / m2"}>
                        <Field
                            id={"price"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Cena całk."}>
                        <Field
                            id={"flat_price"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Czynsz"}>
                        <Field
                            id={"rent_amount"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Zwrot %"}>
                        <Field
                            id={"gain_factor"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Pow. użytk."}>
                        <Field
                            id={"flat_area"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                    <Property label={"Pow. działki"}>
                        <Field
                            id={"plot_area"}
                            fieldType={"text"}
                            variant={"dense"}
                        />
                    </Property>
                </PropertyGrid>
                <Field
                    id={"tags"}
                    label={"Tagi"}
                    fieldType={"select"}
                    source={"api:tags"}
                    multiple={true}
                    taggable={true}
                    nullable={true}
                />
                <MediaField id={"media"} label={"Załączniki"} />
                <Field id={"text"} fieldType={"rich"} />
                <FormSection name={"Pomieszczenia"} collapsed={true}>
                    <FlatRooms id={"levels"} />
                </FormSection>
                {/*<Form type={type} id={id} />*/}
            </div>
        </FormLayout.Fieldset>
    );
}

FlatsForm.propTypes = {};

FlatsForm.defaultProps = {};

export default FlatsForm;
